import React from 'react';
import styles from '../../styles/Sidebar.module.scss';

const IconPhone = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <rect x="7" y="2" width="10" height="20" rx="2" />
    <circle cx="12" cy="18" r="1" />
  </svg>
);

const IconUser = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
  </svg>
);

const IconCompany = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="9" cy="9" r="3" />
    <circle cx="17" cy="10" r="2.5" />
    <path d="M2 20c0-3.5 3.1-6 7-6s7 2.5 7 6" />
    <path d="M14 20c0-2.2 1.8-4 4-4" />
  </svg>
);

const IconPin = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 21s7-5.2 7-11a7 7 0 1 0-14 0c0 5.8 7 11 7 11z" />
    <circle cx="12" cy="10" r="2.5" />
  </svg>
);

const IconChat = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4 5h13a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H9l-5 3V8a3 3 0 0 1 3-3z" />
    <path d="M9 10h9M9 14h6" />
  </svg>
);

const IconMail = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);

const phoneHref = (phone) => `tel:${phone.replace(/[^\d+]/g, '')}`;

const ContactsBlock = ({ contacts, hideHeader = false }) => {
  if (!contacts) return null;

  const {
    phones = [],
    contactPerson,
    company,
    address,
    email,
    telegram,
    viber,
  } = contacts;

  return (
    <div className={styles.contacts}>
      {!hideHeader && (
        <div className={styles.contactsHeader}>
          <span className={styles.contactsTitle}>КОНТАКТИ</span>
          <span className={styles.contactsHeaderIcon}><IconMail /></span>
        </div>
      )}

      {phones.length > 0 && (
        <div className={styles.contactsSection}>
          <div className={styles.contactsSectionHead}>
            <span className={styles.contactsIcon}><IconPhone /></span>
            <span>ТЕЛЕФОНИ</span>
          </div>
          <ul className={styles.contactsList}>
            {phones.map((phone) => (
              <li key={phone}>
                <a href={phoneHref(phone)} className={styles.contactsLink}>{phone}</a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {contactPerson && (
        <div className={styles.contactsSection}>
          <div className={styles.contactsSectionHead}>
            <span className={styles.contactsIcon}><IconUser /></span>
            <span>КОНТАКТНА ОСОБА</span>
          </div>
          <p className={styles.contactsText}>{contactPerson}</p>
        </div>
      )}

      {company && (
        <div className={styles.contactsSection}>
          <div className={styles.contactsSectionHead}>
            <span className={styles.contactsIcon}><IconCompany /></span>
            <span>КОМПАНІЯ</span>
          </div>
          <p className={styles.contactsText}>{company}</p>
        </div>
      )}

      {address && (
        <div className={styles.contactsSection}>
          <div className={styles.contactsSectionHead}>
            <span className={styles.contactsIcon}><IconPin /></span>
            <span>АДРЕСА</span>
          </div>
          <p className={styles.contactsText}>{address}</p>
        </div>
      )}

      {(email || telegram || viber) && (
        <div className={styles.contactsSection}>
          <div className={styles.contactsSectionHead}>
            <span className={styles.contactsIcon}><IconChat /></span>
            <span>ДОДАТКОВІ ВИДИ ЗВ&apos;ЯЗКУ</span>
          </div>
          <div className={styles.contactsChannels}>
            {email && (
              <p>
                <span className={styles.contactsChannelLabel}>E-mail:</span>{' '}
                <a href={`mailto:${email}`} className={styles.contactsEmail}>{email}</a>
              </p>
            )}
            {telegram && (
              <p>
                <span className={styles.contactsChannelLabel}>Telegram:</span>{' '}
                <a href={`https://t.me/${telegram.replace(/[^\d+]/g, '')}`} className={styles.contactsLink} target="_blank" rel="noreferrer">
                  {telegram}
                </a>
              </p>
            )}
            {viber && (
              <p>
                <span className={styles.contactsChannelLabel}>Viber:</span>{' '}
                <a href={`viber://chat?number=${viber.replace(/[^\d+]/g, '')}`} className={styles.contactsLink}>
                  {viber}
                </a>
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactsBlock;
